module.exports = __webpack_public_path__ + "static/media/crocodile(32).0caf3943.PNG";